export default "__VITE_ASSET__5If9_kCB__"